















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryGoodsList, BatchAddActivityGoods, QuerySupplierList, AddBindGoodds } from '@/api'
import { Message, MessageBox } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { PriceFormat } from '@/utils/tyepconvert'
import { getNameById } from '@/store/classifyStore'

@Component({
  components: { VTable, VQuery },
})
export default class AddBindGoodsDialog extends Vue {
  @Emit('close')
  private close() {
    this.show = false
    this.data = []
    this.tableData = []
    this.tableCurrntPage = 1
  }
  public open(data: any) {
    this.show = true
    this.data = data
    this.loadData()
  }
  private show = false
  private data: any = {}
  private queryParam = {
    startRow: 0,
    limit: 5,
  }
  private tableData = []
  private tableCurrntPage = 1

  private supplierOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    this.supplierQueryParam,
    { title: '商品名称', param: 'goodsName' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = []
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '供应商编号', param: 'supplierCode' },
    { title: '商品名称', param: 'goodsName' },
    { title: '一级分类', param: 'goodsOneClassifyId', formatter: getNameById },
    { title: '二级分类', param: 'goodsTwoClassifyId', formatter: getNameById },
    { title: '单位', param: 'goodsUnit' },
    { title: '销售金额', param: 'salesIntegral', formatter: PriceFormat },
    { title: '奖励积分', param: 'rewardIntegral', formatter: PriceFormat },
    { title: '库存', param: 'inventory' },
    { title: '状态', param: 'goodsStatus', formatter: (value: number) => (value == 0 ? '已下架' : '已上架') },
    {
      title: '操作',
      operation: [{ title: '绑定', click: this.bind }],
    },
  ]

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow = 0
    param.limit = 5
    const result = await QueryGoodsList(param)
    this.tableData = result.list
  }

  public search() {
    this.loadData()
    this.loadSupplier()
  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  private async bind(goods: any){
    const param = {
      videoId: this.data.id,
      goodsId: goods.id
    }
    await AddBindGoodds(param)
    this.close()
  }

 
}
